<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-control-section>
    <a *ngIf="isMobile()" alt="Open Widget Toolbar" (click)="toggleToolbar()" class="btn active filter">
      <span class="fa-stack">
        <i class="fa fa-lg" [ngClass]="{'fa-caret-right' : !toolbarDisplayed, 'fa-caret-down' : toolbarDisplayed}"></i>
      </span>
    </a>
    <a alt="Edit Filter" (click)="filterDialog.showFilterDialog(currentFilter)" class="btn active filter" title="Advanced Filter">
      <span class="fa-stack">
        <i class="fa fa-filter fa-stack-1x fa-lg"></i>
        <i *ngIf="hasCustomFilter" class="fa fa-check fa-stack-1x custom-filter"></i>
      </span>
    </a>
  </ng-container>

  <ng-template #filters>
    <div class="widget-toolbar" [ngClass]="{ 'mobile-mode' : isMobile(), 'mobile-mode-displayed': toolbarDisplayed }">
      <div class="widget-toolbar-menu">
        <label>Balance by</label>
        <p-dropdown hideDropdownOnScroll panelStyleClass="widget-dropdown" [options]="chartGroupTypes" [(ngModel)]="selectedChartGroupType" (onChange)="updateGrouping()" appendTo="body" dataKey="Id" optionLabel="Label" placeholder="Select a chart group type"></p-dropdown>
        <label>as at {{currentDate | date:'d MMM y'}}</label>
        <label>for currency</label>
        <p-dropdown hideDropdownOnScroll panelStyleClass="widget-dropdown" [options]="currencyOptions" [(ngModel)]="selectedCurrency" (onChange)="updateGrouping()" appendTo="body" data1Key="Code" optionLabel="Code"></p-dropdown>
      </div>
      <div class="widget-toolbar-buttons">
        <a alt="Button1" [ngClass]="{active: (view$ | async) == 'cashBalanceTable'}" (click)="changeToTableView()"
          class="btn"><span class="fa fa-th-large fa-lg"></span></a>
        <a alt="Button2" [ngClass]="{active: (view$ | async) == 'bar'}" (click)="changeToBarView()" class="btn"><span
            class="fa fa-bar-chart fa-lg"></span></a>
      </div>
    </div>
  </ng-template>

  <ng-container widget-body>
    <ng-container *ngTemplateOutlet="filters"></ng-container>
    <div class="widget-content">
      <p-progressSpinner *ngIf="(loading$ | async)"></p-progressSpinner>

      <label class="cash-balanaces-title">{{getTitle()}}</label>
      <mojo-cash-balance-table *ngIf="(view$ | async) == 'cashBalanceTable'" [data]="cashBalancesForTable$ | async"
                               [totalRow]="totalRowForTable$ | async"
        [loading]="loading$ | async" [currentCurrency]="selectedCurrency"></mojo-cash-balance-table>
      <mojo-cash-balance-chart *ngIf="(view$ | async) == 'bar'" [cashBalanceChartData]="cashBalancesForChart$ | async"
        [loading]="loading$ | async" [chartFontColour]="chartFontColour" [chartGridLineColour]="chartGridLineColour"
        [chartColours]="chartColours" [currentCurrency]="selectedCurrency"></mojo-cash-balance-chart>
    </div>
  </ng-container>


  <mojo-filter-editor-dialog #filterDialog (onCancel)="filterEditCancelled($event)"
    (onSaveFilter)="filterEdited($event)" [queryConfig]="queryConfig"
    [sysAdminFilterText]="sysAdminFilterText$ | async"></mojo-filter-editor-dialog>

</mojo-widget>
